import type { Variants } from "framer-motion";

export const listVariants: Variants = {
  show: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};
export const itemVariants: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 0.75, ease: [0.37, 0, 0.63, 1] },
  },
};
